<template>
  <div class="panel-close-hotspots">
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      enableLeft: state => state.panels.left,
      enableRight: state => state.panels.right
    })
  },
  mounted() {
    document.addEventListener('click', this.clickListener, { capture: true })  
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickListener, { capture: true })
  },
  methods: {
    clickListener(e) {
      if (this.enableLeft || this.enableRight) {
        if (this.isInPanel(e.target)) return
        if (e.x > window.innerWidth/2) {
          this.closeRight()
        } else {
          this.closeLeft()
        }
      }
    },
    closeLeft() {
      this.$store.commit('setPanelVisibleLeft', false)
    },  
    closeRight() {
      this.$store.commit('setPanelVisibleRight', false)
    },
    isInPanel(child) {
      let node = child.parentNode;
      while (node != null) {
          if (node.classList && node.classList.contains('panel')) {
            return true
          }
          if (node.hasAttribute && node.hasAttribute('data-dont-hide-panels')) {
            return true
          }
          node = node.parentNode;
      }
      return false;
    }
  }
}
</script>
